const CHECKOUT_SELECTOR =
  'main product-form-component shopify-accelerated-checkout';

function copyAttribute(source, target, name) {
  if (!source.hasAttribute(name)) return;
  target.setAttribute(name, source.getAttribute(name) || '');
}

function createNativeBuyNow(checkout) {
  const nativeBuyNow = document.createElement('shopify-buy-it-now-button');

  copyAttribute(checkout, nativeBuyNow, 'access-token');
  copyAttribute(checkout, nativeBuyNow, 'buyer-country');
  copyAttribute(checkout, nativeBuyNow, 'buyer-currency');
  copyAttribute(checkout, nativeBuyNow, 'requires-shipping');

  nativeBuyNow.setAttribute('wallet-params', '{}');
  nativeBuyNow.setAttribute('page-type', 'product');
  nativeBuyNow.setAttribute('slot', 'button');
  nativeBuyNow.setAttribute('call-to-action', '');

  const button = document.createElement('button');
  button.type = 'button';
  button.className =
    'shopify-payment-button__button shopify-payment-button__button--unbranded';
  button.textContent = 'Buy it now';
  nativeBuyNow.append(button);

  return nativeBuyNow;
}

function keepOnlyNativeBuyNow(checkout) {
  if (!(checkout instanceof HTMLElement)) return;

  let nativeBuyNow = checkout.querySelector(
    ':scope > shopify-buy-it-now-button'
  );

  if (!nativeBuyNow) {
    nativeBuyNow = createNativeBuyNow(checkout);
    checkout.replaceChildren(nativeBuyNow);
  } else {
    for (const child of [...checkout.children]) {
      if (child !== nativeBuyNow) child.remove();
    }
  }

  checkout.dataset.nativeBuyNowOnly = 'true';
}

function normalizeAcceleratedCheckouts(root = document) {
  for (const checkout of root.querySelectorAll(CHECKOUT_SELECTOR)) {
    keepOnlyNativeBuyNow(checkout);
  }
}

let normalizationQueued = false;
function queueNormalization() {
  if (normalizationQueued) return;
  normalizationQueued = true;
  queueMicrotask(() => {
    normalizationQueued = false;
    normalizeAcceleratedCheckouts();
  });
}

normalizeAcceleratedCheckouts();

const observer = new MutationObserver(queueNormalization);
observer.observe(document.documentElement, {
  childList: true,
  subtree: true,
});

